import React, { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { wishItemActions } from "constants/options"
import { useAppSelector } from "appRedux/hooks"
import { updateSearchedUserIsLoggedInUser } from "appRedux/slices/globalSlice"
import useWishItem from "hooks/useWishItem"
import useResolveCurrentItemIndex from "hooks/useResolveCurrentItemIndex"
import WishItemPageTemplate from "components/templates/WishItemPageTemplate"

export default function WishItemPage() {
  const wishListState = useAppSelector((state) => state.wishList)

  useWishItem()

  const dispatch = useDispatch()

  const wishItems = useMemo(() => {
    return wishListState?.itemInfo ? [wishListState?.itemInfo] : []
  }, [wishListState?.itemInfo])

  useResolveCurrentItemIndex(wishItems)

  useEffect(() => {
    dispatch(updateSearchedUserIsLoggedInUser(false))
  }, [])

  return (
    <WishItemPageTemplate
      wishItems={wishItems}
      moreButtonActions={wishItemActions}
    />
  )
}
